import { HugeiconsIcon } from "@hugeicons/react";
import { OrientationLandscapeToPotraitIcon } from "@hugeicons-pro/core-stroke-rounded";

export default function RotateIcon() {
  return (
    <HugeiconsIcon
      icon={OrientationLandscapeToPotraitIcon}
      size={64}
      color="currentColor"
      strokeWidth={1.5}
    />
  );
}
